/**
 * User-facing message from API/client errors (FetchError, axios-style, Error).
 */
export function getApiErrorMessage(error: unknown): string {
  if (error && typeof error === 'object' && 'data' in error) {
    const fetchLike = error as { data?: { message?: unknown; error?: unknown }; message?: unknown }
    const fromDataMessage = fetchLike.data?.message
    if (typeof fromDataMessage === 'string' && fromDataMessage.length > 0) {
      return fromDataMessage
    }
    const fromDataError = fetchLike.data?.error
    if (typeof fromDataError === 'string' && fromDataError.length > 0) {
      return fromDataError
    }
    const topMessage = fetchLike.message
    if (typeof topMessage === 'string' && topMessage.length > 0) {
      return topMessage
    }
  }

  if (error && typeof error === 'object' && 'response' in error) {
    const axiosLike = error as { response?: { data?: { message?: unknown; error?: unknown } } }
    const msg = axiosLike.response?.data?.message
    if (typeof msg === 'string' && msg.length > 0) {
      return msg
    }
    const err = axiosLike.response?.data?.error
    if (typeof err === 'string' && err.length > 0) {
      return err
    }
  }

  if (error instanceof Error && error.message.length > 0) {
    return error.message
  }
  if (typeof error === 'string' && error.length > 0) {
    return error
  }
  return ''
}
